var _ellipse, _path, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6567,
    cy: 20.2935,
    rx: 20.2192,
    ry: 20.2935,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5863 27.8156C25.5863 25.4868 23.2761 23.5879 20.4181 23.5879C17.5602 23.5879 15.25 25.4768 15.25 27.8156M20.4181 20.3454C21.1603 20.3454 21.872 20.0495 22.3968 19.5229C22.9215 18.9962 23.2163 18.2818 23.2163 17.537C23.2163 16.7921 22.9215 16.0778 22.3968 15.5511C21.872 15.0244 21.1603 14.7285 20.4181 14.7285C19.676 14.7285 18.9643 15.0244 18.4395 15.5511C17.9148 16.0778 17.62 16.7921 17.62 17.537C17.62 18.2818 17.9148 18.9962 18.4395 19.5229C18.9643 20.0495 19.676 20.3454 20.4181 20.3454Z",
    stroke: "#092056",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.46,
    cy: 20.1198,
    rx: 9.46,
    ry: 9.49478,
    stroke: "#092056",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfile);
export default __webpack_public_path__ + "static/media/new_profile.5fad11a2477ecbfc8844e61d68fff53b.svg";
export { ForwardRef as ReactComponent };